import cn from 'clsx'
import { StyledTabs } from './style'

const Tabs = ({
  children,
  className,
  defaultActiveKey,
  layout = 1,
  ...rest
}) => {
  return (
    <StyledTabs
      className={cn(className)}
      defaultActiveKey={defaultActiveKey}
      $layout={layout}
      {...rest}
    >
      {children}
    </StyledTabs>
  )
}

export { default as TabContainer } from 'react-bootstrap/TabContainer'
export { default as Tab } from 'react-bootstrap/Tab'
export { default as TabContent } from 'react-bootstrap/TabContent'
export { default as TabPane } from 'react-bootstrap/TabPane'
export default Tabs
